import React, { Component } from 'react'
import { Row, Col } from 'react-flexbox-grid'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import Paper from '@material-ui/core/Paper'
import Card from '@material-ui/core/Card'
import Divider from '@material-ui/core/Divider'
import HCSAPopupMessage from '../../util/ui/HCSAPopupMessage'
import { localize } from '../../util/Localizer'
import NoServerError from '../../widgets/SubmitAClaim/NoServerError'
import FileUpload from '../../widgets/SubmitAClaim/FileUpload'
import Config from '../../Config'
import { passMessage, clearNavDialog, goNext } from '../../redux/actions/submitNavigationActions'
import { updateClaim } from '../../redux/actions/submitAClaimActions'

import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'

// redux
const onlineSubmit = 'onlineSubmit'
const photoUpload = 'photoUpload'
// const hcsaClaim = 'hcsaClaim'
// const newClaim = 'newClaim'

class ClaimSubmissionOption extends Component {
  constructor () {
    super()
    this.updateNext = this.updateNext.bind(this)
    this.updateFileList = this.updateFileList.bind(this)
    this.sendPopupMessage = this.sendPopupMessage.bind(this)
    this.updateMva = this.updateMva.bind(this)

    this.state = {
      type: null,
      mvaRelated: null
    }
  }

  componentDidMount () {
    this.props.updateUrl(null)
    this.props.setPercent(50)
    this.props.adjustScrollBar()
    this.updateNext()
  }

  componentDidUpdate (prevProps) {
    const { dialogRsp } = this.props
    if ((dialogRsp !== prevProps.dialogRsp) && (dialogRsp === true || dialogRsp === false)) {
      this.props.goNext()
    } else {
      this.updateNext()
    }
  }

  static getDerivedStateFromProps (props, state) {
    const { claimObj = {} } = props
    const { claimSubmitType } = claimObj

    if (claimSubmitType !== state.claimSubmitType) {
      return { type: claimSubmitType }
    } else {
      return null
    }
  }

  updateNext () {
    if (!this.state.type || this.state.type === 'dentalAccident') {
      this.props.setNext(null)
      this.props.passMessage(undefined)
    } else {
      if (this.state.type === photoUpload) {
        const { claimObj = {} } = this.props
        const { MVARelated, type } = claimObj
        const EHCclaim = (type !== 'Drug' && type !== 'Dental')
        if (Config.showMvaQuestion && (MVARelated !== 'true' && MVARelated !== 'false' && EHCclaim)) {
          // if question is shown, dont move forward till complete
          this.props.setNext('')
        } else {
          this.sendPopupMessage()
          this.props.setNext('certifcationAndAuthorization')
        }
      } else {
        this.props.passMessage(undefined)
        this.props.setNext('practitioner')
      }
    }
  }

  updateFileList (fileList, claimSubmitType) {
    const claimObj = {
      ...this.props.claimObj,
      claimSubmitType,
      ImageContent: fileList || []
    }

    this.props.updateClaim(claimObj)
    if (!Config.showMvaQuestion) {
      this.setState({ type: claimSubmitType }, () => this.updateNext())
    } else {
      this.setState({ type: claimSubmitType })
    }
  }

  updateMva (value) {
    const { claimObj = {} } = this.props
    // mva content is being moved to claim common on submission because it is
    // currently overwritten by the hcsa popup
    const nextClaimObj = {
      ...claimObj,
      MVARelated: value
    }
    this.props.updateClaim(nextClaimObj)
    this.updateNext()
  }

  chooseSubmissionType (claimSubmitType) {
    const claimObj = {
      ...this.props.claimObj,
      claimSubmitType
    }

    if (claimSubmitType !== photoUpload) {
      claimObj.ImageContent = []
    }

    this.props.updateClaim(claimObj)

    if (!Config.showMvaQuestion) {
      this.setState({ type: claimSubmitType }, () => this.updateNext())
    } else {
      this.setState({ type: claimSubmitType })
    }
  }

  renderError () {
    return (
      <div>
        <NoServerError error={this.props.error} />
      </div>
    )
  }

  sendPopupMessage () {
    const { memberSummary } = this.props
    if (memberSummary.healthCareSpendingAccountBalance > 0 && this.state.type === photoUpload) {
      const message = HCSAPopupMessage({
        balance: memberSummary.healthCareSpendingAccountBalance
      })
      this.props.passMessage(message)
    }
  }

  claimFiles () {
    if (this.props.claimObj) {
      return this.props.claimObj.ImageContent || []
    } else {
      return []
    }
  }

  renderInvalidType () {
    return (
      <div>
        <p>{localize('pages.SubmitAClaim.PhotoUpload.InvalidClaimSelectionText')}</p>
      </div>
    )
  }

  renderBody () {
    if (!this.props.error) {
      const onlineSubmitTypeClass = this.state.type === onlineSubmit ? { className: 'submissionTypeOnlineSelected', elevation: 3 } : { className: 'submissionTypeOnlineBox', elevation: 1 }
      // const photoSubmitTypeClass = this.state.type === photoUpload ? { className: 'submissionTypePhotoSelected', elevation: 3 } : { className: 'submissionTypePhotoBox', elevation: 1 }
      const textToBold = localize('pages.SubmitAClaim.PhotoUpload.UploadImages.BoldText')
      const [firstPart, secondPart] = localize('pages.SubmitAClaim.PhotoUpload.UploadImages').split(textToBold)
      const { claimObj = {} } = this.props
      const { ImageContent = [], type = '' } = claimObj
      // check theme to ensure iuoe users can only submit images
      const { wlKey } = Config
      const EHCclaim = type !== 'Drug' && type !== 'Dental'
      return (
        <Row>
          <Col xs={12}>
            {wlKey !== 'iuoe' && <React.Fragment>
              <Row center='xs' middle='xs'>
                <Col>
                  <p className='bold'>{localize('pages.SubmitAClaim.PhotoUpload.SelectAnOption')}</p>
                </Col>
              </Row>
              <Row center='xs' middle='xs'>
                <Col>
                  <p>{localize('pages.SubmitAClaim.PhotoUpload.Subtitle')}</p>
                </Col>
              </Row>
            </React.Fragment>}
            <Row center='xs' middle='xs'>
              <Col xs={12} sm={10} md={5} lg={5}>
                {wlKey !== 'iuoe' && <React.Fragment>
                  <Row>
                    <Col xs={12}>
                      <Paper {...onlineSubmitTypeClass} onClick={() => this.chooseSubmissionType(onlineSubmit)}>
                        <Row center='xs' middle='xs' className='boxRow'>
                          <Col>
                            <p>
                              <i className='fa fa-file-text fa-4x' aria-hidden='true' />
                            </p>
                            <p>{localize('pages.SubmitAClaim.PhotoUpload.EnterClaimDetailsText')}</p>
                          </Col>
                        </Row>
                      </Paper>
                    </Col>
                  </Row>
                  <br />
                  <Row center='xs' middle='xs'>
                    <Col xs={5}>
                      <Divider />
                    </Col>
                    <Col xs={2}>
                      {localize('pages.SubmitAClaim.NewClaim.Or')}
                    </Col>
                    <Col xs={5}>
                      <Divider />
                    </Col>
                  </Row></React.Fragment>}
                <Row center='xs' middle='xs'>
                  <Col >
                    <p>{firstPart}<span className='bold'>{localize('pages.SubmitAClaim.PhotoUpload.UploadImages.BoldText')}</span>{secondPart}</p>
                  </Col>
                </Row>
                <FileUpload
                  onUpdateFileList={this.updateFileList}
                  type={this.state.type}
                  hasCOB={this.props.claimObj && this.props.claimObj.cob}
                  fileSize={Config.maxFileSize}
                  initialFileList={this.claimFiles()}
                  multiple />
              </Col>
            </Row>
            {ImageContent.length > 0 && Config.showMvaQuestion && EHCclaim && <Row>
              <Col xs={12}>
                <p>{localize('pages.SubmitAClaim.Expenses.mvaRelatedLabel')}</p>
                <RadioGroup
                  aria-label={localize('pages.SubmitAClaim.Expenses.mvaRelatedLabel')}
                  value={claimObj.MVARelated}
                  onChange={(e, v) => this.updateMva(v)}
                >
                  <FormControlLabel
                    value={'true'}
                    control={<Radio color={'primary'} />}
                    label={localize('pages.SubmitAClaim.Expenses.mvaRelatedYes')}
                  />
                  <FormControlLabel
                    value={'false'}
                    control={<Radio color={'primary'} />}
                    label={localize('pages.SubmitAClaim.Expenses.mvaRelatedNo')}
                  />
                  <p className='mvaNoText'>{localize('pages.SubmitAClaim.Expenses.mvaRelatedNoText')}</p>
                </RadioGroup>
              </Col>
            </Row>}
          </Col>
        </Row>
      )
    }
  }

  render () {
    let content = ''
    if (this.props.error) {
      content = this.renderError()
    } else if (!this.props.claimObj || (this.props.claimObj.claimType && this.props.claimObj.claimType === 'hcsaClaim')) {
      content = this.renderInvalidType()
    } else {
      content = this.renderBody()
    }

    return (
      <Card className='submitCard'>
        <Row start='xs'>
          <Col xs={12}>
            <h3>{localize('pages.SubmitAClaim.PhotoUpload.Title')}</h3>
            {content}
          </Col>
        </Row>
      </Card>
    )
  }
}

function mapStateToProps (state, ownProps) {
  return {
    claimObj: state.SubmitAClaimReducer.claimObj,
    error: state.SubmitAClaimReducer.error,
    memberSummary: state.memberSummaryReducer.memberSummary,
    dialogRsp: state.SubmitNavigationReducer.dialogRsp
  }
}
const ConnectedClaimSubmissionOption = connect(mapStateToProps, { updateClaim, passMessage, clearNavDialog, goNext })(injectIntl(ClaimSubmissionOption))
export default ConnectedClaimSubmissionOption



// WEBPACK FOOTER //
// ./src/components/SubmitAClaim/ClaimSubmissionOption.js